import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height?: number;
  width?: number;
  color: string;
}

const IconUserOctagon = (props: SvgComponentProps) => {
  const { color } = props;

  return (
    <SvgWrapper>
      <svg
        width="19"
        height="18"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.40013 15.1667C7.95347 15.1667 7.50013 15.0533 7.10013 14.82L3.14013 12.5333C2.34013 12.0666 1.84013 11.2066 1.84013 10.28V5.72C1.84013 4.79333 2.34013 3.93333 3.14013 3.46666L7.10013 1.18C7.90013 0.713335 8.89347 0.713335 9.70013 1.18L13.6601 3.46666C14.4601 3.93333 14.9601 4.79333 14.9601 5.72V10.28C14.9601 11.2066 14.4601 12.0666 13.6601 12.5333L9.70013 14.82C9.30013 15.0533 8.8468 15.1667 8.40013 15.1667ZM8.40013 1.83332C8.1268 1.83332 7.8468 1.90666 7.60013 2.04666L3.64013 4.33332C3.1468 4.61999 2.84013 5.14667 2.84013 5.72V10.28C2.84013 10.8466 3.1468 11.38 3.64013 11.6667L7.60013 13.9533C8.09347 14.24 8.7068 14.24 9.20013 13.9533L13.1601 11.6667C13.6535 11.38 13.9601 10.8533 13.9601 10.28V5.72C13.9601 5.15333 13.6535 4.61999 13.1601 4.33332L9.20013 2.04666C8.95347 1.90666 8.67347 1.83332 8.40013 1.83332Z"
          fill={color}
        />
        <path
          d="M8.39998 7.83338C7.26664 7.83338 6.34664 6.91337 6.34664 5.78003C6.34664 4.6467 7.26664 3.72673 8.39998 3.72673C9.53331 3.72673 10.4533 4.6467 10.4533 5.78003C10.4533 6.91337 9.53331 7.83338 8.39998 7.83338ZM8.39998 4.72673C7.81998 4.72673 7.34664 5.20003 7.34664 5.78003C7.34664 6.36003 7.81998 6.83338 8.39998 6.83338C8.97998 6.83338 9.45331 6.36003 9.45331 5.78003C9.45331 5.20003 8.97998 4.72673 8.39998 4.72673Z"
          fill={color}
        />
        <path
          d="M11.0667 11.6067C10.7934 11.6067 10.5667 11.3801 10.5667 11.1067C10.5667 10.1867 9.59336 9.43344 8.40003 9.43344C7.2067 9.43344 6.23336 10.1867 6.23336 11.1067C6.23336 11.3801 6.0067 11.6067 5.73336 11.6067C5.46003 11.6067 5.23336 11.3801 5.23336 11.1067C5.23336 9.6334 6.65336 8.43344 8.40003 8.43344C10.1467 8.43344 11.5667 9.6334 11.5667 11.1067C11.5667 11.3801 11.34 11.6067 11.0667 11.6067Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default IconUserOctagon;
